export const isVisibleField = (value?: string) => typeof value === "string" && value !== "hidden";
